import FormattedMessage from 'I18n/components/FormattedMessage';
import { getButtonVariantProps } from 'pricing-pages-lib/utils/buttonVariantUtils';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import SignupButton from 'pricing-pages-ui/components/common/SignupButton';
import SkeletonLoadWrapper from 'pricing-pages-ui/components/common/loading/SkeletonLoadWrapper';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { FREE_CARD } from '../../constants/tracking/TrackingSources';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import HighlightedFreePriceDisplay from '../merch-card/price-display/HighlightedFreePriceDisplay';
import MobileSuiteBusinessObjectives from './MobileSuiteBusinessObjectives';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileSuiteFreeTile = ({
  gridItemProps
}) => {
  const isAppReady = useGlobalLoading();
  const ctaVariantProps = getButtonVariantProps({
    variant: 'block'
  });

  // In order for the grid to work, we need this to remain enclosed in a Fragment and not a div.
  // Children of the display grid item must get the grid-start attributes directly
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PPUIGridItem, Object.assign({}, gridItemProps, {
      paddingBlockStart: "600",
      showBorderTop: true,
      position: "relative",
      gridRowStart: 1,
      children: /*#__PURE__*/_jsx(SectionTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.suiteTile.freeCard.title"
        })
      })
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({}, gridItemProps, {
      paddingBlockStart: "600",
      gridRowStart: 2,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.suiteTile.freeCard.description"
      })
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({}, gridItemProps, {
      paddingBlockStart: "400",
      gridRowStart: 3,
      children: /*#__PURE__*/_jsx(HighlightedFreePriceDisplay, {})
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({}, gridItemProps, {
      paddingBlockStart: "400",
      gridRowStart: 5,
      children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: !isAppReady,
        heights: [47],
        widths: ['100%'],
        children: /*#__PURE__*/_jsx(SignupButton, Object.assign({
          sourceId: "pricing-hero",
          productLine: "crm",
          use: "primary",
          trackingSource: FREE_CARD
        }, ctaVariantProps))
      })
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({}, gridItemProps, {
      paddingBlockStart: "400",
      paddingBlockEnd: "600",
      gridRowStart: 6,
      showBorderBottom: true,
      children: /*#__PURE__*/_jsx(MobileSuiteBusinessObjectives, {
        productLevel: FREE
      })
    }))]
  });
};
export default MobileSuiteFreeTile;